import {createSlice} from "@reduxjs/toolkit";

export const optionsSlice = createSlice(
    {
        name: 'options',
        initialState:{
            teams:[],
            typesArr:[],
            types:{},
        },
        reducers:{
            setTeams:(state,{payload})=>{
                state.teams = payload
            },
            setTypes:(state,{payload})=>{
                // [[type,label],...]
                state.typesArr = Object.entries(payload);
                state.types = payload;
            }
        }
    }
);

export const {setTeams,setTypes} = optionsSlice.actions;

export default optionsSlice.reducer;